import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useQueryClient } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';
import { OfferTeam, SaveOfferTeamMaxQuantityRequest } from './type';

const saveOfferTeamMaxQuantity = async ({
  offerId,
  teamId,
  maxQuantity,
}: SaveOfferTeamMaxQuantityRequest): Promise<OfferTeam> => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/offers/${offerId}/teams/${teamId}`;

  return request({
    url,
    method: RequestMethod.PUT,
    body: { maxQuantity },
  });
};

export const useSaveOfferTeamMaxQuantity = () => {
  const queryClient = useQueryClient();

  return useGenericMutation<OfferTeam, RequestError, SaveOfferTeamMaxQuantityRequest>(
    [QUERY_KEYS.getOfferTeams],
    saveOfferTeamMaxQuantity,
    {
      onSuccess: (_data, variables) => {
        void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getOfferTeams, variables.offerId] });
      },
    }
  );
};
